import { render, staticRenderFns } from "./News.html?vue&type=template&id=a5be5890&scoped=true&"
import script from "./News.ts?vue&type=script&lang=ts&"
export * from "./News.ts?vue&type=script&lang=ts&"
import style0 from "./News.css?vue&type=style&index=0&id=a5be5890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5be5890",
  null
  
)

export default component.exports